'use strict';

const numberFormats = require('../data/enums/number-formats');

const formatCompetitorPriceHistoryLabel = (
  competitor,
  numberFormatter,
  indexFormat,
  addToLabel
) => {
  const formattedPrice = numberFormatter({
    number: competitor.competitorPrice,
    format: numberFormats.priceFormat,
  });

  return addToLabel(`${formattedPrice}`, competitor, numberFormatter, indexFormat);
};

const addCompetitorIndex = (baseLabel, competitor, numberFormatter, indexFormat) => {
  const formattedIndex = numberFormatter({
    number: competitor.livePriceIndex,
    format: indexFormat,
  });
  return `${baseLabel} / ${formattedIndex}`;
};

module.exports = {
  formatCompetitorPriceHistoryLabel,
  addCompetitorIndex,
};
